<script lang="ts">
  const investors = [
    { name: 'BlockChange Ventures', url: 'https://blockchange.vc', logo: '/logos/investors/blockchange.png' },
    { name: 'Delphi Ventures', url: 'https://delphiventures.io', logo: '/logos/investors/delphi.svg' },
    { name: 'Decasonic', url: 'https://www.decasonic.com', logo: '/logos/investors/decasonic.png' },
    { name: 'New Form Capital', url: 'https://www.newformcap.com', logo: '/logos/investors/newform.svg' },
    { name: 'Auros Global', url: 'https://www.auros.global', logo: '/logos/investors/auros.jpg' },
    { name: 'Generative Ventures', url: 'https://www.genventures.xyz', logo: '/logos/investors/generative.png' },
    { name: 'Contango Digital', url: 'https://www.contango.digital', logo: '/logos/investors/contango.png' },
    { name: 'Santiago Santos', url: 'https://twitter.com/santiagoroel', logo: null }
  ];

  function initials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((w) => w[0])
      .join('');
  }
</script>

<section class="backed-by" id="investors">
  <div class="container">
    <div class="backed-by-inner" data-animate>
      <h2 class="section-title">Backed by the <span>Best in the Business</span></h2>
      <div class="backed-by-grid">
        {#each investors as investor}
          <a class="investor-card" href={investor.url} target="_blank" rel="noopener">
            <span class="investor-chip">
              {#if investor.logo}
                <img src={investor.logo} alt={investor.name} loading="lazy" />
              {:else}
                <span class="investor-initials">{initials(investor.name)}</span>
              {/if}
            </span>
            <span class="investor-name">{investor.name}</span>
          </a>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  .backed-by {
    padding: var(--section-py) 0;
    background: var(--bg);
  }

  .backed-by-inner {
    text-align: center;
  }

  .section-title {
    font-family: var(--font-display);
    font-size: clamp(1.875rem, 4vw, 3rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 48px;
    letter-spacing: -0.025em;
    line-height: 1.2;
  }

  .section-title span {
    position: relative;
    display: inline-block;
  }

  .section-title span::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0.1em;
    height: 4px;
    background: var(--editorial);
  }

  .backed-by-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1px;
    max-width: 800px;
    margin: 0 auto;
    background: var(--editorial-muted);
    border: 2px solid var(--editorial-muted);
  }

  .investor-card {
    background: var(--bg);
    padding: 28px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    transition: background 0.3s ease;
    text-decoration: none;
  }

  .investor-card:hover {
    background: var(--bg-raised);
  }

  /* White chip so logos of any design (light-on-dark or dark-on-light) stay
     legible and consistent on the dark grid. */
  .investor-chip {
    width: 100%;
    max-width: 132px;
    height: 56px;
    background: #fff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    box-sizing: border-box;
  }

  .investor-chip img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }

  .investor-initials {
    font-family: var(--font-display);
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: #111;
  }

  .investor-name {
    font-family: var(--font-mono);
    font-size: 0.7rem;
    color: var(--fg-muted);
    text-align: center;
    line-height: 1.35;
    transition: color var(--transition);
  }

  .investor-card:hover .investor-name {
    color: var(--fg);
  }

  @media (max-width: 768px) {
    .backed-by-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>
